import React from 'react';
import {LogoIcon, LogoText} from "../../../assets/images/images";
import {withRouter} from "react-router-dom";

function Header(props) {
  const headerHandler = () => {
    props.history.push('/')
  }
  return (
    <div className='display-flex align-items-center justify-content-center m-0 bg-green pt-10 pb-10 sticky-header  mouse-pointer'
         style={{top: 0}} onClick={headerHandler}>
      <img src={LogoIcon} alt={''} width={50}/>
      <img src={LogoText} alt={''} width={90}/>
    </div>
  );
}

export default withRouter(Header);
